import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { DialogTabsMenu } from "@/partner/shared/components/DialogTabsMenu";
import { PagePaths } from "@/partner/shared/constants";
import { ENTRYPOINT_TABS, type StreamEntrypointTab } from "../model";

// По образцу StreamTabsMenu.tsx (streams-фича): тонкая обёртка над общим
// DialogTabsMenu, тут только лейблы вкладок.
export const StreamEntrypointTabsMenu: FC<{ tab: StreamEntrypointTab }> = ({
  tab,
}) => {
  const { t } = useTranslation();

  const labels: Record<StreamEntrypointTab, string> = {
    edit: t("streamEntrypoints.tabs.edit"),
    broadcast: t("streamEntrypoints.tabs.broadcast"),
    monitoring: t("streamEntrypoints.tabs.monitoring"),
  };

  return (
    <DialogTabsMenu
      tabs={ENTRYPOINT_TABS}
      value={tab}
      labels={labels}
      basePath={PagePaths.streamEntrypoints}
    />
  );
};
